const middleware = {}

middleware['redirects-fix'] = require('../middleware/redirects-fix.js')
middleware['redirects-fix'] = middleware['redirects-fix'].default || middleware['redirects-fix']

export default middleware
